export default "__VITE_ASSET__CHAl_zQ___"